"use client";

import { useEllimae } from "@/store/useEllimae";
import { addContext, updateSessionContext } from "@/services/datadog.service";
import { useEffect } from "react";

const ENV = process.env.NEXT_PUBLIC_NODE_ENV || "development";

export const DatadogSetup = () => {
  const {
    originResponse: origin,
    initialized: ellimaeInitialized,
    sessionId,
    transactionId,
  } = useEllimae((state) => state);

  // Set basic context (clientId, loanId, environment)
  useEffect(() => {
    if (ellimaeInitialized && origin) {
      const { clientId, encompassLoanId } = origin;
      addContext("clientId", clientId);
      addContext("loanId", encompassLoanId);
      addContext("environment", ENV);
    } else {
      addContext("environment", ENV);
      addContext("mode", "localhost-outside-encompass");
    }
  }, [origin, ellimaeInitialized]);

  // Update session context whenever audit details change
  // This ensures all errors/logs have the latest audit identifiers
  useEffect(() => {
    if (ellimaeInitialized && origin) {
      updateSessionContext({
        sessionId: sessionId || null,
        loanId: origin.encompassLoanId || null,
        transactionId: transactionId || null,
        transactionStateId: origin.auditDetail?.transactionStateId || null,
        auditRunId: origin.auditDetail?.id || null,
      });
    }
  }, [
    ellimaeInitialized,
    origin,
    sessionId,
    transactionId,
    origin?.auditDetail?.id,
    origin?.auditDetail?.transactionStateId,
  ]);

  return null;
};
